/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@domain-group/fe-co-icon';
import * as gtag from '../../lib/gtag';
import * as commonLandingStyles from './landingpage.styles';
import * as styles from './process.styles';

interface ProcessItemProps {
  title: string;
  description: string;
  isOpen: boolean;
  onClick: React.MouseEventHandler;
}

const ProcessItem: FC<ProcessItemProps> = ({
  title,
  description,
  isOpen,
  onClick,
}) => (
  <li css={styles.processListItem(isOpen)} onClick={onClick}>
    <span>
      <h3>{title}</h3>
      {(isOpen && <ChevronUpIcon />) || <ChevronDownIcon />}
    </span>
    <p>{description}</p>
  </li>
);

const Process: FC = () => {
  const [expandedProcess, setExpandedProcess] = useState(-1);

  const toggleExpandedProcess = (processToExpand: number) => {
    let expand = processToExpand;
    if (expand === expandedProcess) {
      expand = -1;
    }
    gtag.event({
      category: 'landing-page',
      action: 'click',
      label: 'landing-process-expand',
      value: expand,
    });
    setExpandedProcess(expand);
  };

  return (
    <div css={commonLandingStyles.sectionContainer}>
      <h2 css={commonLandingStyles.sectionHeader}>Start using Domain APIs</h2>
      <ol css={styles.processList}>
        <ProcessItem
          title="Create an account"
          description="Sign up today using your Github, Google account or plain email to create your account and start your project."
          isOpen={expandedProcess === 1}
          onClick={() => toggleExpandedProcess(1)}
        />
        <ProcessItem
          title="Explore Domain APIs"
          description="Explore Domain APIs with a wide range of packages providing unique data access. Each package includes step by step guides and references to individual endpoints to accelerate your development speed."
          isOpen={expandedProcess === 2}
          onClick={() => toggleExpandedProcess(2)}
        />
        <ProcessItem
          title="Build and Test"
          description="Create your first project and try the Live API Browser to experience the data format of each endpoint. Test your project in the sandbox environment before launching."
          isOpen={expandedProcess === 3}
          onClick={() => toggleExpandedProcess(3)}
        />
        <ProcessItem
          title="Go live"
          description="Hooray! You are now live in production powered by Domain data."
          isOpen={expandedProcess === 4}
          onClick={() => toggleExpandedProcess(4)}
        />
      </ol>
    </div>
  );
};

export default Process;
